import { motion } from "framer-motion";
import { X } from "lucide-react";
import NotificationItem from "./NotificationItem";

/**
 * Animated popover panel with the activity list and mark-all-read action.
 */
export default function NotificationsPanel({ items, unread, onMarkRead, onMarkAll, onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -8, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -8, scale: 0.97 }}
      transition={{ duration: 0.15 }}
      data-testid="notifications-panel"
      className="absolute right-0 top-12 w-80 max-h-[480px] overflow-y-auto glass-heavy rounded-2xl p-3 z-50 shadow-2xl"
    >
      <div className="flex items-center justify-between px-2 py-1">
        <div className="text-sm font-display font-bold text-[#0F172A]">Activity</div>
        <div className="flex items-center gap-2">
          {unread > 0 && (
            <button
              data-testid="notifications-mark-all"
              onClick={onMarkAll}
              className="text-xs text-[#00E5FF] hover:underline"
            >
              Mark all read
            </button>
          )}
          <button onClick={onClose} className="text-[#64748B] hover:text-[#0F172A]" aria-label="Close">
            <X size={14} />
          </button>
        </div>
      </div>
      {items.length === 0 ? (
        <div className="text-xs text-[#64748B] px-3 py-6 text-center">No notifications yet.</div>
      ) : (
        <ul className="space-y-1.5 mt-2">
          {items.map((n) => (
            <NotificationItem key={n.id} n={n} onMarkRead={onMarkRead} />
          ))}
        </ul>
      )}
    </motion.div>
  );
}
